import { REFETCH_ON, REFETCH_OFF } from "../types/vehicleManageType";

// Action Functions
export const refetchOn = () => ({ type: REFETCH_ON });
export const refetchOff = () => ({ type: REFETCH_OFF });
